
import { ConnectButton } from '@rainbow-me/rainbowkit';
import NormalBtn from './StockItems/NormalBtn';

export const ConnectingButton = () => {
  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        // Note: If your app doesn't use authentication, you
        // can remove all 'authenticationStatus' checks
        const ready = mounted && authenticationStatus !== 'loading';
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus ||
            authenticationStatus === 'authenticated');

        return (
          <div
            {...(!ready && {
              'aria-hidden': true,
              'style': {
                opacity: 0,
                pointerEvents: 'none',
                userSelect: 'none',
              },
            })}
          >
            {(() => {
              if (!connected) {
                return (
                    <NormalBtn onClick={openConnectModal} title='Connect Wallet' icon='material-symbols:wallet' oppositeColor={true}/>
                );
              }

              if (chain.unsupported) {
                return (
                  <NormalBtn onClick={openChainModal} title='Wrong Network' icon='mdi:network-off-outline' oppositeColor={true}/>
                );
              }

              return (
                <div style={{ display: 'flex', gap: 12 }}>
                 

                  <button style={{fontFamily:'Righteous', borderWidth:1, borderStyle:'solid', backgroundColor:'rgb(255, 103, 103)', cursor:'pointer'}} className='btn   col-2    ml-0  mr-1' onClick={openAccountModal} type="button">
                    {account.displayName}
                    {account.displayBalance
                      ? ` (${account.displayBalance})`
                      : ''}
                  </button>
                </div>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
};

